<script>
import FullCalendar from "@fullcalendar/vue";
import dayGridPlugin from "@fullcalendar/daygrid";
import timeGridPlugin from "@fullcalendar/timegrid";
import interactionPlugin from "@fullcalendar/interaction";
import bootstrapPlugin from "@fullcalendar/bootstrap";
import listPlugin from "@fullcalendar/list";
import axios from "axios";

export default {
  name: "calendarCard",
  components: {
    FullCalendar,
  },
  props: {
    influencer: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    userType () {
      return this.$store.getters['user/userType'];
    },
  },
  async beforeMount() {
    const campaigns = (await axios.get(`/${this.userType}/influencer/${this.influencer._id}/campaigns-calendar`)).data;
    for (const campaign of campaigns) {
      campaign.title = campaign.public_name
      campaign.start = campaign.start_date
      campaign.end = campaign.end_date

      this.calendarOptions.initialEvents.push(campaign);
    }

    this.calendarEventsLoaded = true;
  },
  data() {
    return {
      calendarEventsLoaded: false,
      calendarOptions: {
        displayEventTime: false,
        headerToolbar: {
          left: "prev,next today",
          center: "title",
          right: ""
        },
        plugins: [
          dayGridPlugin,
          timeGridPlugin,
          interactionPlugin,
          bootstrapPlugin,
          listPlugin
        ],
        initialView: "dayGridMonth",
        themeSystem: "bootstrap",
        initialEvents: [
        ],
        editable: false,
        droppable: false,
        eventResizableFromStart: false,
        weekends: true,
        selectable: false,
        selectMirror: false,
        dayMaxEvents: false
      }
    }
  }
}
</script>

<template>
  <div class="card">
    <div class="card-body ">
      <div class="app-calendar ">
        <FullCalendar v-if="this.calendarEventsLoaded" ref="fullCalendar" :options="calendarOptions"></FullCalendar>
      </div>
    </div>
  </div>
</template>

<style scoped>

</style>
